import AnimatedEmoji from "@components/AnimatedEmoji"
import Layout from "@components/Layout"
import LoadingStep from "@components/LoadingStep"
import { motion } from "framer-motion"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"

const STEPS_TOTAL = 3

export default function GettingReadyPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [isPreferencesSaved, setIsPreferencesSaved] = useState(false)
  const [isAiModelsReady, setIsAiModelsReady] = useState(false)
  const [isFineTuningModels, setIsFineTuningModels] = useState(false)

  const completedSteps = [
    isPreferencesSaved,
    isAiModelsReady,
    isFineTuningModels,
  ].filter(Boolean).length
  const progress = (completedSteps / STEPS_TOTAL) * 100

  useEffect(() => {
    const timeoutPreferencesSaved = setTimeout(() => {
      setIsPreferencesSaved(true)
    }, 2000)

    const timeoutAiModelsReady = setTimeout(() => {
      setIsAiModelsReady(true)
    }, 4000)

    const timeoutFineTuningModels = setTimeout(() => {
      setIsFineTuningModels(true)
    }, 6000)

    const timeoutNavigate = setTimeout(() => {
      navigate("/checkout/plans")
    }, 7000)

    return () => {
      clearTimeout(timeoutPreferencesSaved)
      clearTimeout(timeoutAiModelsReady)
      clearTimeout(timeoutFineTuningModels)
      clearTimeout(timeoutNavigate)
    }
  }, [navigate])

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center gap-10 text-center">
        <AnimatedEmoji emoji="✨" className="text-7xl" />

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="w-full space-y-6"
        >
          <h1 className="heading">{t("pages.signUp.ready.heading")}</h1>

          <div className="mx-auto w-full max-w-xs space-y-1">
            <div className="h-1.5 w-full overflow-hidden rounded-full bg-white/10">
              <motion.div
                className="h-full rounded-full bg-white"
                initial={{ width: "0%" }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.6, ease: "easeInOut" }}
              />
            </div>
          </div>

          <div className="mx-auto w-full max-w-xs space-y-4 rounded-2xl bg-white/5 px-6 py-5">
            <LoadingStep
              label={t("pages.signUp.ready.preferencesSaved")}
              isComplete={isPreferencesSaved}
            />
            <LoadingStep
              label={t("pages.signUp.ready.aiModelsAreReady1")}
              isComplete={isAiModelsReady}
            />
            <LoadingStep
              label={t("pages.signUp.ready.fineTuningModels")}
              isComplete={isFineTuningModels}
            />
          </div>
        </motion.div>
      </div>
    </Layout>
  )
}
